"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.adjustSprintEndDate = exports.addDuration = exports.nearestDayTime = void 0;
var moment_timezone_1 = __importDefault(require("moment-timezone"));
/**
 * Finds the nearest instance of a day of week, hours, minutes from given timestamp.
 *
 * For example:
 *  - nereastDayTime(2020-02-15 Monday 16:00, Tuesday 12:00) -> 2020-02-16 Tuesday 12:00
 *  - nereastDayTime(2020-02-15 Monday 12:00, Monday 16:00) -> 2020-02-15 Monday 16:00 (same day of week)
 *  - nereastDayTime(2020-02-15 Monday 16:00, Monday 12:00) -> 2020-02-22 Monday 12:00 (same day of week)
 *  - nearestDayTime(2020-02-15 Monday 16:00, Monday 16:00) -> 2020-02-15 Monday 16:00 (same day and hours)
 */
function nearestDayTime(date, dayOfWeek, hours, minutes) {
    if (date.day() !== dayOfWeek) {
        // Different day of week
        // Jump over days difference and set the hours
        return date
            .clone()
            .add((7 + dayOfWeek - date.day()) % 7, 'days')
            .hours(hours)
            .minutes(minutes)
            .seconds(0);
    }
    // Same day of week
    // Create a new timestamp with new hours on the same date
    var timestampWithNewHours = date.clone().hours(hours).minutes(minutes).seconds(0);
    // It's going to be either the same date or a week after
    if (timestampWithNewHours.diff(date) < 0) {
        // The new timestamp happens earlier so the same day next week
        return timestampWithNewHours.add(1, 'week');
    }
    return timestampWithNewHours;
}
exports.nearestDayTime = nearestDayTime;
function addDuration(date, duration) {
    switch (duration) {
        case '1 week':
            return moment_timezone_1.default(date).add(1, 'week').toDate();
        case '2 weeks':
            return moment_timezone_1.default(date).add(2, 'weeks').toDate();
        case '1 hour':
            return moment_timezone_1.default(date).add(1, 'hour').toDate();
    }
}
exports.addDuration = addDuration;
function adjustSprintEndDate(startDate, sprintSettings, now) {
    // Convert now timestamp to moment in given timezone
    var nowMoment = moment_timezone_1.default(now);
    if (sprintSettings.timezone) {
        nowMoment.tz(sprintSettings.timezone);
    }
    // Calculate start + duration
    var startDatePlusDuration = moment_timezone_1.default(startDate);
    if (sprintSettings.timezone) {
        startDatePlusDuration.tz(sprintSettings.timezone);
    }
    if (sprintSettings.duration === '1 week' || sprintSettings.duration === '2 weeks') {
        // Leave out a buffer of 3 days
        // This way we can find a proper sprint end in case of timezone/daylight saving time changes
        var durationWeeks = sprintSettings.duration === '1 week' ? 1 : 2;
        startDatePlusDuration.add(durationWeeks * 7 - 3, 'days');
    }
    else {
        startDatePlusDuration.add(1, 'hour');
    }
    // Take "now" or "start + duration" whichever is later
    var referenceTimestamp = nowMoment.isAfter(startDatePlusDuration) ? nowMoment : startDatePlusDuration;
    // For 1 hour sprints - ignore endDay, endHours, endMinutes
    if (sprintSettings.duration === '1 hour') {
        return referenceTimestamp.toDate();
    }
    // Find the nearest possible sprint end
    var endTime = nearestDayTime(referenceTimestamp, sprintSettings.endDay, sprintSettings.endHours, sprintSettings.endMinutes);
    return endTime.toDate();
}
exports.adjustSprintEndDate = adjustSprintEndDate;
